import { Alert } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import { setShowMissingBillingCodeTemplateModal } from "app/store/manualUpload/slice/manualUploadSlice";
import { convertArrayToCommaSeparatedString } from "utils/string";

const MissingBillingCodeTemplateModal = () => {
  const { missingTemplateBillingCodes, showMissingBillingCodeTemplateModal } =
    useSelector((state) => state.manualUpload);

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setShowMissingBillingCodeTemplateModal(false));
  };

  return (
    <ModalWrapper
      show={showMissingBillingCodeTemplateModal}
      showTitle={true}
      showCloseIcon={true}
      headerStyle={{ padding: "4px 24px" }}
      onClose={onClose}
      title="Missing Billing Code Templates"
      actionButtons={[
        {
          label: "OK",
          variant: "contained",
          color: "secondary",
          onClick: onClose,
        },
      ]}
      showContentDivider
    >
      <Alert severity="warning" className="mt-2 mb-2">
        Selected{" "}
        {convertArrayToCommaSeparatedString(missingTemplateBillingCodes)}{" "}
        billing code/s do not have report templates. Please review the selected
        billing codes.
      </Alert>

      <Alert severity="info" className="mt-2 mb-2">
        Contact administrator to add report templates for the missing billing
        codes.
      </Alert>
    </ModalWrapper>
  );
};

export default MissingBillingCodeTemplateModal;
